import { render, staticRenderFns } from "./ExpenseDocumentsPage.vue?vue&type=template&id=59b98baa&scoped=true"
import script from "./ExpenseDocumentsPage.vue?vue&type=script&lang=js"
export * from "./ExpenseDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b98baa",
  null
  
)

export default component.exports